import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'flowaccount-flowpay-qr-payment',
  templateUrl: './flowpay-qr-payment.component.html',
  styleUrls: ['./flowpay-qr-payment.component.scss']
})
export class FlowpayQrPaymentComponent implements OnInit {
  qrCodeTab = 1

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

  onClickTab(tabNo: number): number {
    return this.qrCodeTab = tabNo
  }

}
